import React from 'react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-99" data-mp="1o3ncvzyfwkwu">
      <Reveal className="mx-auto max-w-2xl rounded-2xl border border-amber/50 bg-mist p-9 text-center shadow-premium sm:p-12" data-id="element-100" data-mp="1o3dmwcdeadr5">
        <div aria-hidden="true" className="text-5xl" data-id="element-101" data-mp="1x4bsv07e8vcd">
          🛡️
        </div>
        <h2 className="mt-5 font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-102" data-mp="1x28qrhsyvbra">
          Zero rischi. Garanzia di rimborso 7 giorni.
        </h2>
        <p className="mt-6 text-sm leading-7 text-slate sm:text-base" data-id="element-103" data-mp="14gfp5bjeq363">
          Scarica i 6 tomi e i 5 bonus oggi. Stampa le carte di costellazione. Lavora sui modelli di genogramma. Applica
          le frasi di guarigione. Se entro 7 giorni il sistema non corrisponde alle tue aspettative, contattaci per
          richiedere un rimborso. Senza moduli. Senza domande. Senza problemi. Il rischio è completamente nostro.
        </p>
      </Reveal>
    </section>;
}